export const educationData = [
    {
        id: 1,
        institution: 'Chennai Institute Of Technology | CGPA : 9.4',
        course: 'Bachelor of Engineering, Computer Science ',
        startYear: '2021',
        endYear: '2025'
    },
    {
        id: 2,
        institution: 'Everwin Matriculation Higher Secondary School | 97.14%',
        course: 'Higher Secondary Education',
        startYear: '2021',
        endYear: ''
    },
    {
        id: 3,
        institution: 'Everwin Matriculation Higher Secondary School | 96.4%',
        course: 'Secondary Education',
        startYear: '2019',
        endYear: 'Present'
    },
]